/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const FONTS = {
  "SFProText-Bold": require("./res/fonts/SF-Pro-Text-Bold.otf"),
  "SFProText-Semibold": require("./res/fonts/SF-Pro-Text-Semibold.otf"),
  "SFProText-Regular": require("./res/fonts/SF-Pro-Text-Regular.otf"),
  "conthrax-sb": require("./res/fonts/conthrax-sb.ttf"),
  "Ubuntu-Bold": require("./res/fonts/Ubuntu-Bold.ttf"),
  "Ubuntu-Light": require("./res/fonts/Ubuntu-Light.ttf"),
  "Ubuntu-Medium": require("./res/fonts/Ubuntu-Medium.ttf"),
  "Ubuntu-Regular": require("./res/fonts/Ubuntu-Regular.ttf"),
};
